export default __webpack_public_path__ + "86855ba9d12a8c764f7beddc47222a95.svg";